
import React, { useEffect, useState } from "react";
import DashboardHeader from "@/components/DashboardHeader";
import { API_ROUTES } from "@/services/environment";
import { GET } from "@/services/api";
import { useAppSelector } from "@/hooks/hook";
import 'react-datepicker/dist/react-datepicker.css';
import { useNavigate } from "react-router";
import ChangesAlert from "@/components/alert/ChangesAlert";

interface props {
    businessId: string;

}

const ViewCocktails: React.FC<props> = ({ businessId }) => {
    const navigate = useNavigate()
    const { refreshToken } = useAppSelector((store) => store.user);
    const { cocktailWIthoutGroupBy } = API_ROUTES;
    const [packagesData, setPackagesData] = useState<Array<any>>([]);
    // const [activeId, setActiveId] = useState<string>("");
    const [alert, setAlert] = useState<boolean>(false);
    // const [confirm, setConfirm] = useState<boolean>(false);


    const [loading, setLoading] = useState<boolean>(true);


    useEffect(() => {
        fetchData();
        // Clean-up function
        return () => {
            // Perform any clean-up (if needed)
        };
    }, []); // Empty dependency array to run effect only once on component mount

    const fetchData = async () => {
        // list of all coctails avaialble
        try {
            const result = await GET(`${cocktailWIthoutGroupBy}/${businessId}`, refreshToken);
            setPackagesData(result.data)
            setLoading(false);
        } catch (err) {
            console.log(err);
            // setCustomError('discount', JSON.stringify( err));
        } finally {
            setLoading(false);
        }
    };



    // empty screen if there are no data
    if (packagesData.length == 0) {
        return null
    }

    // table view of cocktails
    return (
        <div>
            <DashboardHeader desc={packagesData.length < 3 ? "(Min 3 Required *)" : ""} title="Available Cocktails">
                {/* <div className="flex justify-end">
                    <Button onClick={() => navigate(`/create-company/?id=${businessId}`, { state: { step: 4, isNew: true } })}>Add New</Button>
                </div> */}
            </DashboardHeader>


            <div className="relative overflow-x-auto shadow-md sm:rounded-lg mt-4 overflow-y-auto max-h-96">
                <table className="w-full text-sm text-left rtl:text-right text-gray-500">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                        <tr>
                            <th scope="col" className="px-6 text-primary-red py-3">
                                Sr#.
                            </th>
                            <th scope="col" className="px-6 text-primary-red py-3">
                                Image
                            </th>
                            <th scope="col" className="px-6 text-primary-red py-3">
                                Coctail Name
                            </th>
                            <th scope="col" className="px-6 text-primary-red py-3 ">
                                Type
                            </th>
                            <th scope="col" className="px-6 text-primary-red py-3">
                                status
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {packagesData.length > 0 &&
                            packagesData?.map((item, index) => {
                                return (
                                    <tr key={index} className="odd:bg-white even:bg-gray-50  border-b ">
                                        <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap ">
                                            {index + 1}
                                        </th>
                                        <td className="px-6 py-4">
                                            <img className="h-14 w-14 object-cover rounded-full " src={item.image} />
                                        </td>
                                        <td className="px-6 py-4">
                                            {item?.name}
                                        </td>
                                        <td className="px-6 py-4">
                                            {item?.type}
                                        </td>
                                        <td className="px-6 py-4">
                                            {item?.status}
                                        </td>
                                        {/* <td className="px-6 py-4">
                                            <div onClick={() => { packagesData.length > 1 ? [setActiveId(item.id), setConfirm(true)] : setAlert(true) }} className="cursor-pointer" >
                                                <DeleteIcon />
                                            </div>
                                        </td> */}
                                    </tr>
                                )
                            })
                        }

                    </tbody>
                </table>
            </div>
            <ChangesAlert
                title={"Delete Alert"}
                desc={`You cant delete the last Coctail!`}
                negativeButtonText={"Okay"}
                handleDiscardChanges={() => { setAlert(false) }}
                isOpen={alert} />
        </div>
    );
};



export default ViewCocktails;








